import { render, staticRenderFns } from "./TransactionHistoryListForUser.vue?vue&type=template&id=52bf98a6&scoped=true&"
import script from "./TransactionHistoryListForUser.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryListForUser.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryListForUser.vue?vue&type=style&index=0&id=52bf98a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf98a6",
  null
  
)

export default component.exports